import { trackEvent } from '@fs/zion-analytics'
import { getPreference, setPreference } from '@fs/zion-preferences'
import useFetchData from './useFetchData'
import useStateManager from './useStateManager'

/*
  The hint level preference is at “match.service” and looks like this:
  "value" : {
    "recordHintLevel" : 3
  }
*/

// Our toggle switches between allowing hint level of:
// 3,4,5 when true
// 4,5 when false or unset
const DEFAULT_HINT_LEVEL = 4
const CHECKED_HINT_LEVEL = 3

const fetchExpandedRecordHint = async () => {
  const expandedHintingPreference = await getPreference('match.service')
  const recordHintLevel = expandedHintingPreference?.recordHintLevel || DEFAULT_HINT_LEVEL // default to 4 if user has not chosen a preference
  return recordHintLevel < DEFAULT_HINT_LEVEL
}

const updateExpandedRecordHint = async (checked) => {
  const recordHintLevel = checked ? CHECKED_HINT_LEVEL : DEFAULT_HINT_LEVEL
  trackEvent({
    event_name: 'click_action',
    link_name: checked ? 'Opt-In ExpandedRecordHints' : 'Opt-Out ExpandedRecordHints',
  })
  await setPreference('match.service', { recordHintLevel })
}

export default function useExpandedRecordHint() {
  const { data: remoteExpandedRecordHint, loading: expandedRecordHintLoading } = useFetchData(fetchExpandedRecordHint, {
    initialData: false,
  })

  const { state: localExpandedRecordHint, handleChangeState: handleChangeExpandedRecordHint } = useStateManager(
    (checked) => updateExpandedRecordHint(checked)
  )

  const expandedRecordHint = localExpandedRecordHint ?? remoteExpandedRecordHint
  return {
    expandedRecordHint,
    expandedRecordHintLoading,
    handleChangeExpandedRecordHint,
  }
}
